<ngb-timepicker
    name="time"
    [meridian]="true"
    [spinners]="false"
    [(ngModel)]="condition.time"
    (ngModelChange)="onChange()"
>
    <!-- Time Picker -->
</ngb-timepicker>